import React from 'react';
import { connect } from 'react-redux';

const TransAnchor = (props) => {
  
  var url = props.url;
  if (props.lang !== props.defaultLang) {
    url = props.url.includes('http') ? props.url : (props.url.charAt(0) === '/') ? `/${props.lang}${props.url}` : `/${props.lang}/${props.url}`;
  }

  if (props.className && props.target) {
    return <a href={url} className={props.className} target={props.target}>{props.name}</a>;
  }

  if (props.className)
    return <a href={url} className={props.className}>{props.name}</a>;

  if (props.target)
    return <a href={url} target={props.target}>{props.name}</a>;


  return (
    <a href={url}>{props.name}</a>
  );
};

const mapStateToProps = state => ({ lang: state.langCode, defaultLang: state.defaultLangCode });

export default connect(mapStateToProps)(TransAnchor);



// WEBPACK FOOTER //
// ./src/Common/Translations/TransAnchor.js